import { PaginatedObject, Response, ResponsePagination } from "@interfaces/response";
import { baseApi } from "./baseApi";
import { sortCompaniesByName } from "@helpers/generals";
import { Company } from "@interfaces/companies";
import { UUID } from "crypto";

const companyApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCompanies: build.query<Array<Company>, void>({
            query: () => ({
                url: "catalogos/company",
            }),
            transformResponse: (response: ResponsePagination<Company>) => {
                return sortCompaniesByName(response.data.data);
            },
        }),
        getCompaniesPaginated: build.query<PaginatedObject<Company>, string>({
            query: (params) => ({
                url: `catalogos/company?${params}`,
            }),
            transformResponse: (response: ResponsePagination<Company>) => {
                return response.data;
            },
        }),
        getCompany: build.query<Company, UUID>({
            query: (companyId) => ({
                url: `catalogos/company/${companyId}`,
            }),
            transformResponse: (response: Response<Company>) => {
                return response.data;
            },
        }),
        postCompany: build.mutation<Company, Partial<Omit<Company, "id">>>({
            query: (payload) => ({
                url: "catalogos/company",
                method: "POST",
                body: payload,
            }),
            transformResponse: (response: Response<Company>) => {
                return response.data;
            },
        }),
        patchCompany: build.mutation<Company, { companyId: UUID; payload: Partial<Company> }>({
            query: ({ companyId, payload }) => ({
                url: `catalogos/company/${companyId}`,
                method: "PATCH",
                body: payload,
            }),
            transformResponse: (response: Response<Company>) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useGetCompaniesQuery,
    useLazyGetCompaniesQuery,
    useGetCompanyQuery,
    useLazyGetCompanyQuery,
    useLazyGetCompaniesPaginatedQuery,
    usePostCompanyMutation,
    usePatchCompanyMutation,
} = companyApi;
